module.exports = __webpack_public_path__ + "img/icon-advocate.3a38a586.png";